import { render, staticRenderFns } from "./CSidebarNavDropdown.vue?vue&type=template&id=d2517f58&scoped=true"
import script from "./CSidebarNavDropdown.vue?vue&type=script&lang=js"
export * from "./CSidebarNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./CSidebarNavDropdown.vue?vue&type=style&index=0&id=d2517f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2517f58",
  null
  
)

export default component.exports